import React from "react";
import {ListItem, ListItemGroup, Paragraph, SectionHeading} from "../PromotionsText";

const PlayRestrictionsSection = () => (
  <>
    <SectionHeading>Promotional Play Restrictions</SectionHeading>

    <ListItemGroup marker="(a)">
      <Paragraph>
        {"We offer bonuses and promotions to enhance your enjoyment of our games. We therefore expect that you will participate in all bonuses and promotions fairly, so that our other customers too may enjoy our services. We have set out below certain types of play which we consider to be unfair and therefore to be in breach of these Promotion Terms:"}
      </Paragraph>

      <ListItem marker="(1)">
        {"using minimal risk gaming patterns (e.g. low risk gaming, zero risk gaming or equal gaming patterns);"}
      </ListItem>

      <ListItem marker="(2)">
        {"using multiple accounts to obtain more than the number of bonuses or free play permitted for each customer;"}
      </ListItem>

      <ListItem marker="(3)">
        {"sharing personalized promotional offers or bonuses (i.e. promotions or bonuses which are available to specific customers only) received by you e.g. via email, inbox message, links, URLs etc. with others who were not the intended recipient. This includes accessing promotions or bonuses forwarded to you by others when you were not the intended recipient;"}
      </ListItem>

      <ListItem marker="(4)">
        {"concealing your country of residence in order to access a promotion or bonus that is not available in your country of residence;"}
      </ListItem>

      <ListItem marker="(5)">
        {"colluding with other customers in order to take advantages of promotions or bonuses; or"}
      </ListItem>
    </ListItemGroup>

    <ListItem marker="(b)" withBottomMargin>
      {"Where you are in breach of any of the provisions of this Section 12, we may be entitled to cancel any bonuses or promotions applied to your account, reclaim any bonus element of such offers and either settle challenges at the correct odds, void any challenge funded by a bonus, or remove any subsequent winnings. We may also be entitled to levy an administration charge up to the value of the bonus, free play or additional payment to cover our reasonable administrative costs in respect of any such action that we take."}
    </ListItem>
  </>
);

export default PlayRestrictionsSection;
